import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActions = () => {
  const navigate = useNavigate();

  const quickActions = [
    {
      id: 'new-branding',
      title: 'New Branding Item',
      description: 'Create a new branding installation',
      icon: 'Plus',
      color: 'primary',
      action: () => navigate('/branding-cost-calculator')
    },
    {
      id: 'upload-photo',
      title: 'Upload Installation Photo',
      description: 'Document completed installations',
      icon: 'Camera',
      color: 'secondary',
      action: () => navigate('/installation-tracking')
    },
    {
      id: 'pending-approvals',
      title: 'Pending Approvals',
      description: 'Review installation submissions',
      icon: 'CheckCircle',
      color: 'warning',
      count: 7,
      action: () => navigate('/installation-tracking?filter=pending')
    },
    {
      id: 'store-layouts',
      title: 'Update Store Layout',
      description: 'Manage store layout documentation',
      icon: 'Layout',
      color: 'accent',
      action: () => navigate('/store-layout-manager')
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">Quick Actions</h3>
        <Icon name="Zap" size={20} className="text-accent" />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {quickActions?.map((action) => (
          <Button
            key={action?.id}
            variant="ghost"
            onClick={action?.action}
            className="h-auto p-4 justify-start hover:bg-muted/50 transition-all duration-200 group"
          >
            <div className="flex items-start gap-3 w-full">
              <div className={`w-10 h-10 rounded-lg bg-${action?.color}/10 flex items-center justify-center flex-shrink-0 group-hover:bg-${action?.color}/20 transition-colors duration-200`}>
                <Icon name={action?.icon} size={20} className={`text-${action?.color}`} />
              </div>
              
              <div className="flex-1 text-left">
                <div className="flex items-center gap-2">
                  <h4 className="text-sm font-medium text-foreground">{action?.title}</h4>
                  {action?.count && (
                    <span className={`px-2 py-0.5 rounded-full text-xs font-medium bg-${action?.color}/10 text-${action?.color}`}>
                      {action?.count}
                    </span>
                  )}
                </div>
                <p className="text-xs text-muted-foreground mt-1">{action?.description}</p>
              </div>
              
              <Icon name="ChevronRight" size={16} className="text-muted-foreground group-hover:text-foreground transition-colors duration-200" />
            </div>
          </Button>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;